module.exports = __webpack_public_path__ + "img/home_service_mouth.7ac13747.png";